import React, { createContext, useContext, useState, useMemo, useEffect } from 'react';
import { RightsAccess } from '../../../../Components/helper';

const rowHeight = 1122.52 / 50; // A4 height divided by number of rows
export const StateContext = createContext(null);
export default function DPPStateProvider({ children }) {
  const { TestingRight } = RightsAccess();

  const controlsOptions = [
    {
      components: [
        {
          type: 'item',
          id: '1',
          key: 'product_journey',
          label: 'Product Journey',
          supplierVisible: true,
          supplierEditable: true,
          subHeader: {},
          productJourney: {},
          tier: [],
          productType: null,
          transportIcon: null,
          bomType: [],
          mapOptionType: 'static',
          verticalLine: 'dashed ',
          otherConfiguration: {
            subHeaderAlign: 'center',
            subHeaderColor: 'black',
            subHeaderBold: false,
            journeyDescAlign: 'center',
            journeyDescBold: false,
            journeyDescColor: 'black',
            verticalLineColor: 'black',
            Tier1DescriptionAlign: 'center',
            Tier1DescriptionBold: false,
            Tier1DescriptionColor: 'black',
            Tier2DescriptionAlign: 'center',
            Tier2DescriptionBold: false,
            Tier2DescriptionColor: 'black',
            Tier3DescriptionAlign: 'center',
            Tier3DescriptionBold: false,
            Tier3DescriptionColor: 'black',
            Tier4DescriptionAlign: 'center',
            Tier4DescriptionBold: false,
            Tier4DescriptionColor: 'black',
          },
        },
        {
          type: 'item',
          id: '20',
          key: 'product_impact',
          label: 'Product Impact',
          supplierVisible: true,
          supplierEditable: true,
          properties: {
            productImpactType: 'manual',
            subHeaderTitle: '',
            otherConfiguration: {
              subHeadAlignment: 'left',
              subHeadColour: 'black',
              subHeadbold: false,
            },
            productImpactDescription: '',
            globalWarmingPotential: '',
            globalWarmingPotentialBreakdown: [{ title: '', value: '' }],
            globalWarmingPotentialDescription: '',
            waterUsage: '',
            waterUsageBreakDown: [{ title: '', value: '' }],
            waterUsageDescription: '',
          },
          otherConfiguration: {
            alignment: 'left',
            colour: 'black',
            bold: false,
          },
        },
        {
          type: 'item',
          id: '21',
          key: 'navigation',
          label: 'Navigation',
          supplierVisible: true,
          supplierEditable: true,
          anchorMenu: [],
        },
        {
          type: 'item',
          id: '4',
          key: 'digital_asset',
          label: 'Digital Asset',
          isSourceControl: true,
          moduleName: 'DAM',
          relation: {
            tags: [],
            location: '',
            attribute: null,
            contentType: [],
          },
        },
        {
          type: 'item',
          id: '5',
          key: 'google',
          label: 'Google',
          supplierVisible: true,
          supplierEditable: true,
          addresses: [{ address: '', lat: 0, lng: 0, placeDetails: null, suggestions: [] }],
          placesNearMe: '',
          isAddressType: 'addresses',
          title: '',
          relatedPlacesNearMe: [],
        },
        {
          type: 'item',
          id: '6',
          key: 'url_link',
          label: 'URL Link',
          thumbnailURL: false,
          url: '',
          replacementText: '',
          showTitle: false,
          showDescription: false,
          metaData: {},
        },
        {
          type: 'item',
          id: '7',
          key: 'source',
          label: 'Source',
          isSourceControl: true,
          moduleName: '',
          relation: {},
          otherConfiguration: {
            sourceSwitchTitle: true, // Default to "on"
          },
        },
        {
          type: 'item',
          id: '9',
          key: 'testing_control',
          label: 'Testing Control',
          testGroup: [
            {
              testGroupTitle: '',
              testIconImage: '',
              testGroupType: [
                {
                  otherConfiguration: {
                    alignment: 'left',
                    colour: 'black',
                    bold: false,
                  },
                  descriptionConfiguration: {
                    otherConfiguration: {
                      descAlignment_0_0: 'left',
                      descColour_0_0: 'black',
                      descBold_0_0: false,
                    },
                  },
                  testTypeManual: '',
                  testTypeAuto: [],
                  testStatus: null,
                  approvalDescription: '',
                  approvalActive: false,
                  approvalCopy: false,
                  rejectedDescription: '',
                  rejectedActive: false,
                  rejectedCopy: false,
                },
              ],
            },
          ],
        },
        {
          type: 'item',
          id: '8',
          key: 'heading',
          label: 'Heading',
          placeholder: 'Heading Title',
          value: '',
          headingType: { label: 'H1', value: 'h1' },
          iconHeading: true,
          iconPath: '',
          otherConfiguration: {
            alignment: 'center',
          },
        },
        {
          type: 'item',
          id: '19',
          key: 'html',
          label: 'HTML',
          supplierVisible: true,
          supplierEditable: true,
          ckeditorData: '',
          htmlBorder: 'dashed',
          otherConfiguration: {
            htmlBorderColor: 'black',
          },
        },
        {
          type: 'item',
          key: 'custom_section',
          id: '30',
          label: 'Custom Section',
          controls: [],
          supplierVisible: true,
          supplierEditable: true,
        },
        {
          type: 'item',
          id: '31',
          key: 'spacer',
          label: 'Spacer',
          supplierVisible: true,
          supplierEditable: true,
        },
        {
          type: 'item',
          key: 'care_user_instruction',
          id: '32',
          label: 'Care/User Instructions',
          supplierVisible: true,
          supplierEditable: true,
          subHeading: '',
          careLabelsArr: [{ careLabel: null, fieldName: null }],
          addMoreInfo: 'yes',
          careLabelDescriptionArr: [{ image: '', title: '', description: '' }],
          otherConfiguration: {
            subHeadAlignment: 'left',
            subHeadColour: 'black',
            subHeadBold: false,
            careAlignment: 'left',
            careColour: 'black',
            careBold: false,
            descriptionAlignment: 'left',
            descriptionColour: 'black',
            descriptionBold: false,
          },
        },
        {
          type: 'item',
          id: '32',
          key: 'company_stamp',
          label: 'Company Stamp',
          placeholder: 'logo',
          value: '',
          iconCompanyPath: '',
          otherConfiguration: {
            alignment: 'center',
          },
        },
      ],
    },
  ];

  const initialState = {
    editPopup: false,
    editpopupData: null,
    editPopupItemIndex: -1,
    tableGridIndex: -1,
    tablePageIndex: -1,
    tableControls: null,
    controlsOption: controlsOptions,
    disableDrag: false,
    modalEdit: false,
    controlPanelOpen: false,
    editCustomSectionIndex: -1,
    navigateId: null,
    careExp: false,
    journeyExp: false,
    impactExp: false,
  };

  const [dppState, setDppState] = useState({ ...initialState });

  useEffect(() => {
    if (!TestingRight) {
      const filteredData = controlsOptions.filter((data) => data.key !== 'testing_control');
      setDppState((otherStates) => ({
        ...otherStates,
        controlsOption: filteredData,
      }));
    }
  }, [TestingRight]);

  const toggleEditPopup = () => {
    setDppState((otherStates) => ({
      ...otherStates,
      editPopup: false,
      editpopupData: null,
      editPopupItemIndex: -1,
      editCustomSectionIndex: -1,
    }));
  };

  const memoizedContextValue = useMemo(
    () => ({
      dppState,
      setDppState,
      initialState,
      toggleEditPopup,
      rowHeight,
    }),
    [dppState, setDppState, initialState, toggleEditPopup, rowHeight],
  );

  return <StateContext.Provider value={memoizedContextValue}>{children}</StateContext.Provider>;
}

export function useDPPState() {
  const context = useContext(StateContext);
  if (!context) {
    throw new Error('useAppState must be used within the DPPStateProvider');
  }
  return context;
}
